export const metersToMi = (meters) => meters / 1609.344;
